import api from "../api/api";

const registerFcmToken = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/notification/guest/fcm",data,
        ).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}



const notificationServices = {
    registerFcmToken
}
export default notificationServices;